module.exports = __webpack_public_path__ + "static/media/wavy_right.dd7b33e2.svg";